<template>
    <div class="wrapper">
        <div class="icon-wrapper">
            <img :src="require('@/assets/icons/murugesh-logo.svg')" alt="">
        </div>
        <p v-motion :initial="{
                opacity: 0,
                y: 100,
            }" :visible-once="{
                opacity: 1,
                y: 0,
            }" class="name">Murugesh <span class="dot">.</span> Raja</p>
    </div>
</template>

<script>
export default {
    name: 'NavBar'
}
</script>

<style scoped>
.wrapper {
    width: 100%;
    display: flex;
    gap: 24px;
    padding: 32px;
    font-family: 'Sans';
    background-color: var(--primary-bg-color);
    align-items: center;
}

.name {
    font-size: 2rem;
    font-weight: 600;
    color: var(--primary-text-color)
}

.icon-wrapper {
    display: flex;
    align-items: center;
    padding: 12px;
    border-radius: 50%;
    background: #0C0C0D;
    border: 1px solid #252626;
    width: 72px;
    height: 72px;
    overflow: hidden;
}

.dot {
    color: #FFA84B;
}

@media (max-width: 768px) {
    .icon-wrapper {
        width: 50px;
        height: 50px;
        overflow: hidden;
    }

    .icon-wrapper img {
        width: 40px;
        height: 40px;
    }

    .name {
        font-size: 1.6rem;
    }
}
</style>